module.exports = __webpack_public_path__ + "img/icon-tire.11f160df.png";